/* @ngInject */
function generalSettingsService (CONSTANTS, $rootScope, Utils, Upload, ConnectorWebService) {
  const service = {
    validSupportEmail,
    uploadCompanyLogo,
    uploadCompanyBackground,
    updateCompany,
    modulesFilter,
    updateOrderFields,
    updateEditableFields,
    createBusinessDataField,
    updateBusinessDataField,
    setLogoSrc
  }
  return service

  function validSupportEmail (supportEmail) {
    const email = supportEmail || ''
    return email.length === 0 || validateEmail(email)
  }

  function validateEmail (email) {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i
    return regex.test(email)
  }

  function updateEditableFields (fields) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_EDITABLE_FIELDS)
    return ConnectorWebService.put(url, { fields })
  }

  function updateOrderFields (fields) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_ORDER_FIELDS)
    return ConnectorWebService.put(url, { fields })
  }

  function modulesFilter (modules) {
    const modulesfilter = Object.keys(modules)
    const removeIt = 'ENABLE_BRAND_ASSETS_MODULE_USER'
    const searchPer = '_MODULE'

    return _removeModule(
      modulesfilter.filter(key => key.indexOf(searchPer) !== -1), removeIt
    )
  }

  function _removeModule (modules, name) {
    const index = modules.indexOf(name)
    if (index !== -1) {
      modules.splice(index, 1)
    }

    return modules
  }

  function uploadCompanyLogo (url, data) {
    url = Utils.fnReplaceStringParams(url, [$rootScope.oUser.customerCompanyId])
    return Upload.upload({
      url,
      data
    })
  }

  function uploadCompanyBackground (url, data) {
    url = Utils.fnReplaceStringParams(url, [$rootScope.oUser.customerCompanyId])

    return Upload.upload({
      url,
      data
    })
  }

  function updateCompany (company) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANIES), company)
  }

  function updateBusinessDataField (field) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_FIELD)
    return ConnectorWebService.put(url, field)
  }

  function createBusinessDataField (field) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_FIELD)
    return ConnectorWebService.post(url, field)
  }

  function setLogoSrc (businessDataField, assetId, user) {
    if (user && user.customerCompanyId) {
      businessDataField.value = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_ID_THUMBNAIL, [assetId])
    }
    return businessDataField
  }
}

export { generalSettingsService }
